import Head from "next/head";

import { defaultServerProps }                         from "_common/ssrWrapper";
import Layout                                         from "_components/pages/blogs/layout";
import Post                                           from "_components/pages/blogs/post";
import { getAllTags, getPostsById, getCategoryNames } from "_services/api/blogs";
import useStyles                                      from "_styles/pages/blogs/postPage";

const component = ( { post, category, categoryNames, tags } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<>
			<Head>
				<title>
					{post.title}
				</title>
			</Head>

			<div className = { classes.postWrapper }>
				<Layout
					categories       = { categoryNames }
					selectedCategory = { category }
				>
					<Post
						post = { post }
						tags = { tags }
					/>
				</Layout>
			</div>
		</>
	);
};

export default component;

const getServerSideProps = async context => defaultServerProps ( context, async defaultProps => {

	const { slug } = context.query || {};

	const [ , postId ] = slug;

	const results = await Promise.allSettled (
		[
			getCategoryNames (),
			getPostsById ( postId ),
			getAllTags ()
		]
	);

	let categoryNames = [], data = null, getTags = [];

	results.forEach ( ( result, index ) => {
		if ( result.status === "fulfilled" ) {
			switch ( index ) {
				case 0:
					categoryNames = result.value;
					break;

				case 1:
					data = result.value;
					break;

				case 2:
					getTags = result.value;
					break;

			}
		}
	} );

	const currentPostCategory = categoryNames.find ( item => item?.id === data?.categories[0] ) || "";

	let filteredPostData = {
		featuredImage : data?.jetpack_featured_media_url || "",
		// yoast_head    : data?.yoast_head,
		title         : data?.title?.rendered || "",
		content       : data?.content?.rendered || "",
		tags          : data?.tags || "",
		date          : data?.date || "",
		postId        : data?.id || null,
		categoryName  : currentPostCategory.name || "",
		slug          : data?.slug || ""
	};

	/* context.res.setHeader (
    "Cache-Control",
    "public, s-maxage=300, stale-while-revalidate=600"
  ); */

	return {
		props: {
			...defaultProps,
			post          : filteredPostData,
			noLayout      : true,
			noAuth        : true,
			category      : currentPostCategory.name || "",
			categoryNames : categoryNames || [],
			tags          : getTags || []
		}
	};
} );

export { getServerSideProps };
